module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile mobileClassTab"
  }, [_c('div', {
    staticClass: "mobile-study"
  }, [(_vm.examTotal > 0) ? _c('van-list', _vm._l((_vm.examLists), function(item) {
    return _c('van-cell', {
      key: item.id,
      staticClass: "list"
    }, [_c('div', {
      staticStyle: {
        "margin-left": "0.426667rem",
        "display": "flex",
        "margin-top": "0.426667rem"
      }
    }, [_c('div', [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": item.courseLogoUrl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "mobile-study-title"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item.examName) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "textImage_he"
    }, [_c('div', {
      staticClass: "period"
    }, [_vm._v("考试时间:" + _vm._s(_vm._f("formatDate")(item.startTime)) + "-" + _vm._s(_vm._f("formatDate")(item.endTime)))]), _vm._v(" "), _c('div', {
      staticClass: "period"
    }, [_vm._v("考试限时:" + _vm._s(item.examDuration) + "分钟")])])])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "mobile-study-btn"
    }, [_c('div', {
      staticClass: "examinationResults"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t考试成绩: "), _c('span', [_vm._v(_vm._s(_vm.questionTotals.score))])]), _vm._v(" "), _c('div', {
      staticClass: "viewResolution",
      on: {
        "click": function($event) {
          return _vm.mobileExamAnalysis(item.lastExamRecordId)
        }
      }
    }, [_vm._v("查看解析")]), _vm._v(" "), (item.userExamStatus == '0') ? _c('van-button', {
      attrs: {
        "round": "",
        "size": "small",
        "type": "danger",
        "to": {
          path: '/mobileExam',
          query: {
            id: item.examId,
          },
        }
      }
    }, [_vm._v("开始考试")]) : _vm._e(), _vm._v(" "), (item.userExamStatus == '1') ? _c('van-button', {
      attrs: {
        "round": "",
        "size": "small",
        "type": "danger",
        "to": {
          path: '/mobileExam',
          query: {
            id: item.examId,
          },
        }
      }
    }, [_vm._v("继续考试")]) : _vm._e(), _vm._v(" "), (item.userExamStatus == '2') ? _c('van-button', {
      attrs: {
        "round": "",
        "size": "small",
        "type": "danger",
        "to": {
          path: '/mobileExam',
          query: {
            id: item.examId,
          },
        }
      }
    }, [_vm._v("重新考试")]) : _vm._e()], 1)])])
  }), 1) : _c('van-list', {
    staticClass: "custom-class-image"
  }, [_c('van-empty', {
    staticClass: "custom-image",
    attrs: {
      "image": "../../../static/images/mobile/examNum.png",
      "description": "暂无考试"
    }
  })], 1)], 1), _vm._v(" "), _c('van-tabbar', {
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tabbar-item', {
    attrs: {
      "to": "/mobileHome"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(props) {
        return [_c('img', {
          attrs: {
            "src": props.active ? _vm.index.active : _vm.index.inactive
          }
        })]
      }
    }])
  }, [_c('span', [_vm._v("首页")])]), _vm._v(" "), _c('van-tabbar-item', {
    attrs: {
      "to": "/mobileStudy"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(props) {
        return [_c('img', {
          attrs: {
            "src": props.active ? _vm.classes.active : _vm.classes.inactive
          }
        })]
      }
    }])
  }, [_c('span', [_vm._v("班级")])]), _vm._v(" "), _c('van-tabbar-item', {
    attrs: {
      "to": "/mobileMy"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(props) {
        return [_c('img', {
          attrs: {
            "src": props.active ? _vm.my.active : _vm.my.inactive
          }
        })]
      }
    }])
  }, [_c('span', [_vm._v("我的")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6efbd6ce"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/MobileExamList.vue
// module id = 1164
// module chunks = 41